import { useEffect, useState } from 'react';
import { Card, Text, BlockStack, Button, Badge, InlineStack } from '@shopify/polaris';
import { settingsRequest, settingsError } from '../api/adminSettings';
import { SecretField, SettingsFeedback, SettingsLoading } from '../components/SettingsFields';

export default function Administration() {
  const [status, setStatus] = useState(null);
  const [form, setForm] = useState({ current_password: '', password: '', password_confirmation: '' });
  const [error, setError] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [success, setSuccess] = useState('');
  const [saving, setSaving] = useState(false);
  const load = async () => { setError(''); try {
    const data = await settingsRequest('g-payment-password');
    if (typeof data?.password_set !== 'boolean') throw new Error('Unable to read password status.');
    setStatus(data);
  } catch (e) { setError(settingsError(e)); } };
  useEffect(() => { load(); }, []);
  const change = key => value => { setForm(prev => ({ ...prev, [key]: value })); setFieldErrors(prev => ({ ...prev, [key]: undefined })); setSuccess(''); };
  const save = async event => {
    event.preventDefault(); setError(''); setSuccess(''); setFieldErrors({});
    if (form.password !== form.password_confirmation) { setFieldErrors({ password_confirmation: 'The new passwords do not match.' }); return; }
    setSaving(true);
    try {
      setStatus(await settingsRequest('u-payment-password', { ...form, password_set: status.password_set }));
      setForm({ current_password: '', password: '', password_confirmation: '' }); setSuccess('Password saved.');
    } catch (e) {
      const errors = e.response?.data?.data?.errors || e.response?.data?.errors;
      if (errors) setFieldErrors(Object.fromEntries(Object.entries(errors).map(([key, messages]) => [key, messages[0]])));
      else setError(settingsError(e));
      if (e.response?.status === 409) setStatus(null);
    }
    finally { setSaving(false); }
  };
  return <div className="settings-administration"><Card><form onSubmit={save}><BlockStack gap="400">
    <InlineStack gap="300" blockAlign="center"><Text as="h2" variant="headingLg">Password protection</Text>{status && <Badge>{status.password_set ? 'Password set' : 'Password not set'}</Badge>}</InlineStack>
    <Text as="p" tone="subdued">Protect access to Payment integration.</Text>
    <SettingsFeedback error={error} success={success} retry={!status ? load : undefined} />
    {!status ? (!error && <SettingsLoading />) : <>
      {status.password_set && <SecretField label="Current secondary password" value={form.current_password} onChange={change('current_password')} error={fieldErrors.current_password} autoComplete="current-password" disabled={saving} />}
      <SecretField label="New secondary password" helpText="Use 8–128 characters." value={form.password} onChange={change('password')} error={fieldErrors.password} disabled={saving} />
      <SecretField label="Confirm new password" value={form.password_confirmation} onChange={change('password_confirmation')} error={fieldErrors.password_confirmation} disabled={saving} />
      <Button submit variant="primary" loading={saving} disabled={!form.password || !form.password_confirmation || (status.password_set && !form.current_password)}>{status.password_set ? 'Update password' : 'Set password'}</Button>
    </>}
  </BlockStack></form></Card></div>;
}
